import React from 'react';
import styled from 'styled-components';

export default styled(({ side, ...rest }) => <img {...rest} />)`
  margin: 0 ${({ side }) => (side === 'left' ? '1rem' : 0)} 0 ${({ side }) => (side === 'right' ? '1rem' : 0)};
  position: relative;
  top: -1px;
  width: 1rem;
`;
